import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-33523056"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "kt_modal_welcome",
  ref: "welcomeModalRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px mh-300px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = {
  class: "btn btn-sm btn-icon btn-active-color-primary",
  "data-bs-dismiss": "modal"
}
const _hoisted_6 = { class: "svg-icon svg-icon-1" }
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div class=\"modal-body py-10 px-lg-17\" data-v-33523056><div class=\"d-flex justify-content-center mb-5\" data-v-33523056><h1 class=\"fs-30\" data-v-33523056>Uhulll... Sua Conta Está Ativa!</h1></div><div class=\"d-flex justify-content-center mb-2\" data-v-33523056><div class=\"text-muted fw-bold fs-5\" data-v-33523056>Bem-vindo ao <a href=\"https://consensu.io/\" target=\"_blank\" data-v-33523056>Consensu.IO. </a> É um prazer enorme ter você por aqui.</div></div><div class=\"d-flex justify-content-center mb-10\" data-v-33523056><div class=\"text-muted fw-bold fs-5 text-center\" data-v-33523056>Estamos confiantes de que nossa solução de privacidade, consentimento e monitoramento de cookies irá ajudá-lo(a) a permitir que seus usuários escolham quais cookies serão armazenados em seu perfil de forma respeitosa e transparente e de acordo com a LGPD.</div></div><div class=\"d-flex justify-content-center mb-2\" data-v-33523056><button class=\"btn btn-primary\" data-bs-dismiss=\"modal\" data-v-33523056>COMEÇAR</button></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, [
              _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
            ])
          ])
        ]),
        _hoisted_7
      ])
    ])
  ], 512))
}